// extracted by mini-css-extract-plugin
export var boxItems = "_a3-1";
export var boxItemsLg = "_a3-2";
export var button = "_a3-7";
export var buttonHoverless = "_a3-9";
export var buttonLg = "_a3-8";
export var filterGroupBox = "_a3-0";
export var icon = "_a3-3";
export var iconSecondary = "_a3-6";
export var iconWrapper = "_a3-4";
export var iconWrapperLg = "_a3-5";
export var truncatedLabel = "_a3-a";